import { Dropdown, Image } from "antd";
import PdfIcon from "../../assets/icons/pdf-icon.svg";
import CsvIcon from "../../assets/icons/csv-icon.svg";

export const getDownloadFormatMenuItems = (onPdf, onCsv) => [
  {
    key: "1",
    icon: <Image width={20} src={PdfIcon} alt="PDF-Icon" preview={false} />,
    label: (
      <span onClick={onPdf} style={{ margin: 10 }}>
        Download as PDF
      </span>
    ),
  },
  { type: "divider" },
  {
    key: "2",
    icon: <Image width={20} src={CsvIcon} alt="CSV-Icon" preview={false} />,
    label: (
      <span onClick={onCsv} style={{ margin: 10 }}>
        Download as CSV
      </span>
    ),
  },
];

const DownloadFormatDropdown = ({
  onPdf,
  onCsv,
  trigger,
  placement = "bottom",
  arrow,
  overlayStyle,
}) => (
  <Dropdown
    menu={{ items: getDownloadFormatMenuItems(onPdf, onCsv) }}
    trigger={["click"]}
    placement={placement}
    arrow={arrow}
    overlayStyle={overlayStyle}
  >
    {trigger}
  </Dropdown>
);

export default DownloadFormatDropdown;
